var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataRisksSuggestionsArrows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6283 11.8946L20.8922 7.75278C21.0359 7.61317 21.0359 7.38683 20.8922 7.24722L16.6283 3.10542C16.3964 2.88022 16 3.03972 16 3.35821V6L9.36364 6C9.16281 6 9 6.16789 9 6.375V8.625C9 8.83211 9.16281 9 9.36364 9L16 9V11.6418C16 11.9603 16.3964 12.1198 16.6283 11.8946Z",
    fill: "#C1C6C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37173 12.1054L3.10779 16.2472C2.96407 16.3868 2.96407 16.6132 3.10779 16.7528L7.37173 20.8946C7.60358 21.1198 8 20.9603 8 20.6418L8 18L15.5909 18C15.8168 18 16 17.8321 16 17.625L16 15.375C16 15.1679 15.8168 15 15.5909 15L8 15L8 12.3582C8 12.0397 7.60358 11.8802 7.37173 12.1054Z",
    fill: "#C1C6C8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataRisksSuggestionsArrows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_risks_suggestions_arrows.9ca3a43cfab55e14f32ba4de93802de0.svg";